export default __webpack_public_path__ + "static/media/Mask of Crimson Slaughter.f8b15b69.jpg";